import { Popover as BlueprintPopover, DefaultPopoverTargetHTMLProps, Placement } from '@blueprintjs/core';
import React from 'react';

export type PopoverPosition =
  | 'auto'
  | 'top'
  | 'top-left'
  | 'top-right'
  | 'left'
  | 'right'
  | 'bottom'
  | 'bottom-left'
  | 'bottom-right';
export type PopoverInteractionKind = 'click' | 'hover' | 'hover-target';

interface IPopoverProps {
  content?: string | React.JSX.Element;
  position?: PopoverPosition;
  interactionKind?: PopoverInteractionKind;
  placement?: Placement;
  className?: string;
  popoverClassName?: string;
  useContentSizing?: boolean;
  disabled?: boolean;
  usePortal?: boolean;
  isOpen?: boolean;
  onInteraction?: (nextOpenState: boolean, e?: React.SyntheticEvent<HTMLElement>) => void;
}

function Popover<T extends DefaultPopoverTargetHTMLProps>({
  content,
  position,
  interactionKind,
  placement,
  className,
  popoverClassName,
  useContentSizing = false,
  disabled,
  usePortal,
  isOpen,
  onInteraction,
  children,
}: React.PropsWithChildren<IPopoverProps>) {
  const popoverContentSizing = useContentSizing ? 'bp5-popover-content-sizing' : '';
  const popoverClass = popoverClassName ? `${popoverContentSizing} ${popoverClassName}` : popoverContentSizing;
  return (
    <BlueprintPopover<T>
      content={content}
      position={position}
      interactionKind={interactionKind}
      placement={placement}
      className={className}
      popoverClassName={popoverClass}
      disabled={disabled}
      usePortal={usePortal}
      isOpen={isOpen}
      onInteraction={onInteraction}>
      {children}
    </BlueprintPopover>
  );
}

export default Popover;
